module.exports = __webpack_public_path__ + "media/src/images/dandori/step9-complete-4cb716e670d107f0e3ef8378a2a55d41.png";